export function createTitle(title) {
  return `${title} | Jiri Palas`
}



// WEBPACK FOOTER //
// ./src/utils/utils.js